import { render, staticRenderFns } from "./matchKindSub.vue?vue&type=template&id=bcf84c7e&scoped=true&"
import script from "./matchKindSub.vue?vue&type=script&lang=js&"
export * from "./matchKindSub.vue?vue&type=script&lang=js&"
import style0 from "./matchKindSub.vue?vue&type=style&index=0&id=bcf84c7e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bcf84c7e",
  null
  
)

export default component.exports